{
	"accessibility.table.selectRow": "Zeile auswählen",
	"accessibility.topbar.openMainMenu": "Hauptmenü öffnen",
	"accessibility.topbar.openUserMenu": "Profilmenü öffnen",
	"account.accountDetails.label.email": "E-Mail-Adresse",
	"account.accountDetails.label.firstName": "Vorname",
	"account.accountDetails.label.lastName": "Nachname",
	"account.accountDetails.label.name": "Profilname",
	"account.accountDetails.label.selfDescription": "Kurzbeschreibung",
	"account.applicationDetails.label.heardAboutSource": "Wie bist du auf das Programm aufmerksam geworden?",
	"account.applicationDetails.label.productCategories": "Welche Produktkategorien wirst du bewerben?",
	"account.applicationDetails.label.promoteProgramme": "Wie wirst du das Affiliate Programm bewerben?",
	"account.applicationDetails.label.recommendedBy": "Von wem wurdest du empfohlen?",
	"account.paymentInformation.label.accountHolder": "Kontoinhaber",
	"account.paymentInformation.label.bankName": "Name der Bank",
	"account.paymentInformation.label.bic": "BIC",
	"account.paymentInformation.label.emailAdress": "E-Mail-Adresse",
	"account.paymentInformation.label.fedwireCode": "FEDWIRE Code",
	"account.paymentInformation.label.iban": "IBAN",
	"account.paymentInformation.label.intervalType": "Auszahlungs-Intervall",
	"account.paymentInformation.label.intlAccountNumber": "Kontonummer",
	"account.paymentInformation.label.intlBankName": "Bankname",
	"account.paymentInformation.label.paymentType": "Zahlungsart",
	"account.paymentInformation.label.swiftCode": "SWIFT-Code",
	"account.paymentInformation.label.taxId": "Steuernummer",
	"account.paymentInformation.label.tradeRegister": "Handelsregister",
	"account.paymentInformation.label.valueAddedTaxId": "Umsatzsteuerid",
	"account.setup.backward": "Zurück",
	"account.setup.channels.title": "Auf welcher Plattform fühlst du dich Zuhause?",
	"account.setup.complete": "Bewerbung abschließen",
	"account.setup.continue": "Nächster Schritt",
	"account.setup.firstStep.description": "Damit wir deine Bewerbung erhalten, musst du das Formular vollständig ausfüllen und abschicken.",
	"account.setup.firstStep.title": "Bewerbung auf {0} von {1}",
	"account.setup.skipSetup.button": "Account Setup überspringen",
	"account.setup.skipSetup.description": "Wenn du das Account Setup überspringst, wirst du nicht automatisch auf das Standard Affiliate Programm beworben. Du kannst dich später aber jederzeit wieder auf das Programm bewerben.",
	"account.setup.skipStep": "Schritt überspringen",
	"account.setup.step.about.label.creatorName": "Publisher Name",
	"account.setup.step.about.title": "Über dich",
	"account.setup.step.verification.title": "Verifizierung",
	"account.setup.stepBackground.label.country": "In welchem Land hast du die größte Reichweite?",
	"account.setup.stepBackground.label.skillLevel": "Wie schätzt du dein Erfahrunslevel ein?",
	"account.setup.stepBackground.option.beginner": "Anfänger",
	"account.setup.stepBackground.option.experienced": "Erfahren",
	"account.setup.stepBackground.option.professional": "Professionell",
	"account.setup.stepBackground.title": "Reichweite & Erfahrung",
	"account.setup.stepBillingPayout.payout.title": "Auszahlung erhalten über",
	"account.setup.stepChannels.title": "Plattform",
	"account.setup.stepGeneral.label.creatorName": "Wie lautet dein Profilname?",
	"account.setup.stepGeneral.label.selfDescription": "Wie würdest du dich oder deinen Content beschreiben?",
	"account.setup.stepGeneral.placeholder.creatorName": "Profilnamen eingeben",
	"account.setup.stepGeneral.placeholder.selfDescription": "Beschreibe dich oder deinen Content",
	"account.setup.stepGeneral.title": "Über dich",
	"account.setup.subtitle": "{name}, gleich hast du es geschafft!",
	"account.setup.success.button": "Zum Dashboard",
	"account.setup.success.nextSteps": "Auch wenn du noch nicht freigeschalten bist kannst du dich bereits mit dem Tool vertraut machen.",
	"account.setup.success.subtitle": "Unsere Affiliate Manger schauen sich deine Bewerbung persönlich an und geben dir schnellstmöglich Rückmeldung über deinen Status.",
	"account.setup.success.title": "{creator}, du hast erfolgreich deine Bewerbung abgeschickt!",
	"account.setup.title": "Profil-Setup",
	"account.setup.verification.title": "Rechnungsadresse",
	"account.socialMedia.label.channelUri": "Kanal-URL",
	"account.socialMedia.label.channelUri.other": "Webseiten-URL",
	"account.socialMedia.label.handle": "Kanalname",
	"account.socialMedia.label.handle.other": "Name",
	"account.socialMedia.label.mainChannel": "Primärkanal",
	"account.socialMedia.label.reach": "Reichweite",
	"account.socialMedia.label.reachCount": "Follower",
	"account.socialMedia.label.reachCount.other": "Eindeutige monatliche Besucher",
	"account.socialMedia.label.reachCount.youtube": "Abonnenten",
	"account.socialMedia.label.tags": "Content-Tags",
	"account.socialMedia.noEntryNote": "Füge jetzt deinen ersten Kanal oder deine erste Website hinzu",
	"account.thomannAffiliatePage.button": "Account verknüpfen",
	"account.thomannAffiliatePage.description": "Damit du im Thomann-Shop Affiliate-Links erzeugen oder eine Landingpage anlegen kannst, verknüpfe deinen Clickfire-Account mit deinem Thomann-Account.",
	"account.thomannAffiliatePage.label": "Mit Thomann Account verbinden",
	"account.thomannAffiliatePage.notApprovedYet": "Die Verknüpfung deines Thomann-Accounts ist noch nicht möglich, da du noch nicht für das Partnerprogramm freigeschaltet bist.",
	"affiliateCard.button.details": "Zur Detailansicht",
	"affiliateCard.button.message": "Nachricht",
	"affiliateCard.noChannelsData": "Der Affiliate hat keine Angaben zu seinen Kanälen gemacht",
	"alert.campaign.notAvailableInYourLanguage": "Die Kampagne ist in deiner ausgewählten Sprache ({0}) nicht verfügbar. Beachte dies bei deiner Einsendung.",
	"alert.dashboard.noProgrammeAssignement": "Herzlich Willkommen bei Clickfire. Du hast dich noch nicht bei einem Affiliate Programm beworben. Schau dir die {link} an, um direkt Loslegen zu können.",
	"alert.dashboard.noProgrammeAssignement.link": "verfügbaren Programme",
	"alert.mfa.active.title": "Multi-Faktor-Authentifizierung ist aktiviert",
	"alert.mfa.unverified.title": "Multi-Faktor-Authentifizierung noch nicht abgeschlossen",
	"alert.mfaSetup.enrollmentError.description": "Bitte gib den Verifizierung Code aus deiner Authentifizierung-App ein.",
	"alert.password.managedExternally": "Dein Profil wird von {0} verwaltet. Dein Passwort lässt sich nur dort ändern.",
	"alert.paymentSettingsConflicting": "Rechnungsdaten aktualisieren",
	"alert.paymentSettingsMissing": "Rechnungsdaten hinterlegen",
	"alert.payout.dataIssue.description": "Deine Zahlungsdaten sind möglicherweise unvollständig oder fehlerhaft. Bitte überprüfe und aktualisiere sie, um Probleme bei der Auszahlung zu vermeiden.",
	"alert.payout.dataIssue.title": "Zahlungsdaten prüfen",
	"alert.productreport.fetchError.description": "Leider können wir deinen Produktreport für den von dir gewählten Zeitraum nicht laden, da die Datenmenge zu groß ist. Wir arbeiten an einer Lösung dafür! Versuche es in der Zwischenzeit mit einem kleineren Zeitraum.",
	"alert.topProductsWidget.error.title": "Fehler beim Laden der Daten",
	"application.noApplications.title": "Keine Bewerbungen vorhanden",
	"applications.label.onlyShowOpenApplications": "Nur offene Bewerbungen",
	"badge.error.campaignDuration": "Laufzeit",
	"badge.error.compensationInEur": "Vergütung",
	"badge.error.language": "Sprache",
	"badge.error.requirements.minSubscribers": "Reichweite",
	"badge.error.requirements.targetCountry": "Zielland",
	"badge.error.thumbnail": "Thumbnail",
	"badge.new": "neu",
	"banner.v1Migration.link": "Hier einmalig mit deinem Account anmelden!",
	"banner.v1Migration.text": "Du kommst vom alten Clickfire?",
	"button.accept": "Akzeptieren",
	"button.acceptApplication": "Annehmen",
	"button.addChannel": "Kanal hinzufügen",
	"button.addMorePlatforms": "Weitere Plattform hinzufügen",
	"button.addPrimaryPlatform": "Primär Plattform hinzufügen",
	"button.addSelection": "Auswahl hinzufügen",
	"button.addUserOrSegmentsForCampaignVisibility": "Creator/Creatorgruppen hinzufügen",
	"button.alreadyAppliedToProgramme": "Beworben",
	"button.alreadyHaveAnClickfireAccount": "Du hast einen Account? Hier gehts zum Login.",
	"button.applyToCampaign": "Bewerben",
	"button.applyToProgramme": "Auf das Programm bewerben",
	"button.archived": "Archivieren",
	"button.backToHome": "Zurück zur Startseite",
	"button.backToLogin": "Zurück zum Login",
	"button.backToOverview": "Zurück zur Übersicht",
	"button.backToPogrammes": "Zur Programmübersicht",
	"button.backToSignup": "Zurück zur Registrierung",
	"button.cancel": "Abbrechen",
	"button.changeBillingData": "Rechnungsdaten ändern",
	"button.changePassword": "Passwort ändern",
	"button.changePaymentInformation": "Zahlungsinformationen ändern",
	"button.close": "Schließen",
	"button.completeMfa": "Vorgang abschließen",
	"button.confirm": "Bestätigen",
	"button.confirmSignupOtp": "Bestätigungscode überprüfen",
	"button.contact": "Kontakt",
	"button.continueInDraftMode": "Als Entwurf fortfahren",
	"button.copied": "Kopiert",
	"button.copyCode": "Code kopieren",
	"button.copyLink": "Link kopieren",
	"button.createCampaign": "Kampagne erstellen",
	"button.creatorPreview": "Creator Vorschau",
	"button.delete": "Löschen",
	"button.deleteCreatorFromSegment": "Creator entfernen",
	"button.deleteTranslation": "Sprache löschen",
	"button.deny": "Ablehnen",
	"button.details": "Details",
	"button.discard": "Verwerfen",
	"button.download": "Download",
	"button.downloadBannerCreative": "Bannergrafik herunterladen",
	"button.downloadCsv": "Download .csv",
	"button.edit": "Bearbeiten",
	"button.editCampaign": "Kampagne bearbeiten",
	"button.editLink": "Tracking-Link bearbeiten",
	"button.filter": "Filter",
	"button.forgotPassword": "Passwort vergessen?",
	"button.generatePersonalizedTrackingLink": "Tracking-Link generieren",
	"button.goBackToClickReport": "zum Klick Report",
	"button.goBackToConversionReport": "zum Conversion-Report",
	"button.goToCampaign": "Kampagne ansehen",
	"button.goToDetails": "Details ansehen",
	"button.goToLogin": "Zum Login",
	"button.grantAccess": "Zugriff gewähren",
	"button.hideChannels": "Channels ausbleben",
	"button.imprint": "Impressum",
	"button.login": "Login",
	"button.loginWithGoogle": "Mit Google anmelden",
	"button.logout": "Logout",
	"button.lookupApplications": "Bewerbungen ansehen",
	"button.lookupSubmissionContentUrl": "Einsendung prüfen",
	"button.lookupSubmissions": "Einsendungen verwalten",
	"button.makeCampaignPrivate": "Auf Privat stellen",
	"button.makeCampaignPublic": "Auf öffentlich stellen",
	"button.manageSubmissions": "Einsendungen verwalten",
	"button.nextStep": "Nächster Schritt",
	"button.noAccountSignup": "Noch kein Account? Registriere dich hier!",
	"button.onlyShowMatches": "Nur Matches anzeigen",
	"button.openSubmissionDetails": "Einsendungsdetails",
	"button.personalizeLink": "Tracking-Link personalisieren",
	"button.privacyPolicy": "Datenschutz",
	"button.publishDraftCampaign": "Kampagne veröffentlichen",
	"button.removeMfa": "Authentifizierungs-App entfernen",
	"button.resendContent": "Neuen Content einsenden",
	"button.resetAllFilter": "Alle Filter zurücksetzen",
	"button.resetPassword": "Passwort zurücksetzen",
	"button.retryApplicationFlow": "Nochmal versuchen",
	"button.reviewSubmission": "Einsendungen einsehen",
	"button.revokeAccess": "Zugriff sperren",
	"button.save": "Speichern",
	"button.saveAsDraft": "Als Entwurf speichern",
	"button.saveCampaignChanges": "Kampagne speichern",
	"button.saveChanges": "Änderungen speichern",
	"button.savePassword": "Passwort speichern",
	"button.send": "Einsenden",
	"button.sendMigrationConformation": "Bestätigungscode senden",
	"button.sendSubmission": "Einsenden",
	"button.setupMfa": "Authentifizierungs-App einrichten",
	"button.showAllChannels": "Channels anzeigen",
	"button.showAllResults": "Ergebnisse anzeigen",
	"button.showMore": "Mehr anzeigen",
	"button.showMoreChannels": "+ {0} weitere Kanäle",
	"button.signupNow": "Registrieren",
	"button.signupWithGoogle": "Mit Google registrieren",
	"button.submitVideo": "Video einsenden",
	"button.toDashboard": "Zum Dashboard",
	"button.toMerchantSelection": "Zur Merchantauswahl",
	"button.toTransmittal": "Zur Einsendung",
	"button.tos": "AGB",
	"button.translateContentWithAi": "Inhalt mit KI übersetzen",
	"button.uploadAvatar": "Bild hochladen",
	"button.uploadImage": "Neues Bild hochladen",
	"button.verifyMfa": "Code bestätigen",
	"campaign.admin.applicationState.accepted": "Angenommen",
	"campaign.admin.applicationState.open": "Offen",
	"campaign.admin.applicationState.rejected": "Abgelehnt",
	"campaign.admin.badge.visibility.private": "Privat",
	"campaign.applicationState.accepted": "Bewerbung angenommen",
	"campaign.applicationState.open": "Beworben",
	"campaign.applicationState.rejected": "Bewerbung abgelehnt",
	"campaign.badge.openApplications": "Ungeprüfte Bewerbungen",
	"campaign.badge.unapprovedSubmissions": "Ungeprüfte Einsendungen",
	"campaign.badge.visibility.private": "Exklusiv",
	"campaign.badge.visibility.public": "Öffentlich",
	"campaign.badge.wasActiveFor": "War aktiv für {0} Tage",
	"campaign.daysRemaining": "Ablauf in {count} Tag | Ablauf in {count} Tagen",
	"campaign.durationExceeded": "Abgelaufen",
	"campaign.property.category": "Kategorie",
	"campaign.property.compensation": "Vergütung",
	"campaign.property.createdAt": "Erstellt am",
	"campaign.property.cta": "CTA",
	"campaign.property.description": "Beschreibung",
	"campaign.property.keyMessage": "Key Message",
	"campaign.property.requirements": "Produkt Exposure",
	"campaign.property.restrictions": "Verbote",
	"campaign.property.videoRequirements": "Video-Anforderungen",
	"campaignHistoricStatus.acceptedNoSubmission": "Zugelassen – Ausstehend",
	"campaignHistoricStatus.applicationPending": "Beworben",
	"campaignHistoricStatus.applicationRejected": "Bewerbung abgelehnt",
	"campaignHistoricStatus.contentApproved": "Inhalt genehmigt",
	"campaignHistoricStatus.contentRejected": "Inhalt abgelehnt",
	"campaignHistoricStatus.contentSubmitted": "Inhalt eingereicht",
	"campaignType.article": "Blog-Post / Webseiten-Artikel",
	"campaignType.bundle": "Content Paket",
	"campaignType.shortVideo": "Shortvideo",
	"campaignType.sparkAd": "SparkAd",
	"campaignType.sponsoredSegment": "Sponsored YouTube-Segment",
	"campaignVisibility.placehoder": "Creator oder Creatorgruppen auswählen",
	"createProgrammeLinkForm.subtitle": "Erstelle einen individuellen Link",
	"createProgrammeLinkForm.title": "Tracking-Link Erstellung",
	"dashboard.widget.commissions.link": "Auszahlungen",
	"dashboard.widget.conversions.link": "Conversion Report",
	"dashboard.widget.topSeller.link": "Product Report",
	"days": "0 Tage | 1 Tag | {count} Tage",
	"description.campaignName": "Der Name ist nur für deine internen Zwecke und wird den Affiliates nicht angezeigt",
	"description.campaignVisibility": "Du kannst deine Kampagne exklusiv nur für bestimmte Creator oder Creatorgruppen freigeben und anzeigen lassen.",
	"description.noVisibilitySettingsYet": "Deine Kampagne ist im Moment für niemanden sichtbar. Füge Creator oder Creatorgruppen hinzu um deine Kampagne sichtbar zu machen oder stelle sie auf öffentlich.",
	"error.fetch.description": "Ein unbekannter Fehler ist aufgetreten. Bitte versuche es später erneut.",
	"error.fetch.title": "Fehler beim Laden der Daten",
	"error.maxDate": "Maximal mögliches Datum ist der ({date})",
	"error.minDate": "Minimal mögliches Datum ist der ({date})",
	"error.noAdmin.subtitle": "Du hast nicht die notwendige Berechtigung um diesen Bereich zu sehen. Du kannst versuchen, dich mit einem anderen Account einzuloggen.",
	"error.noAdmin.title": "Zugang verweigert!",
	"error.noMerchantAccess.otherMerchants.subtitle": "Auf diesen Merchant hast du leider keinen Zugriff. Wir können dich aber zu einem der Merchants weiterleiten, für die du freigeschaltet bist.",
	"error.noMerchantAccess.subtitle": "Auf diesen Merchant hast du leider keinen Zugriff.",
	"error.noMerchantAccess.title": "Zugriff verweigert",
	"error.noValidDateFormat": "Ungültiges Datum",
	"error.rejectedByMerchant.subtitle": "Weitere Informationen haben wir dir per E-Mail zugesendet. Wir bitten um dein Verständnis.",
	"error.rejectedByMerchant.title": "Deine Bewerbung wurde leider abgelehnt",
	"error.signInWithOtp": "Der eingegebene Bestätigungscode ist ungültig. Bitte überprüfe deine Eingabe.",
	"filter.alltime": "Seit Beginn",
	"filter.conversionStatus.all": "Alle",
	"filter.conversionStatus.notRejected": "Ohne abgelehnte",
	"filter.filterOptions": "Filteroptionen",
	"filter.lastDays": "Letzter Tag | Letzten {count} Tage",
	"filter.monthRange": "Letzter Monat | Letzten {count} Monate",
	"filter.price.max": "Max. Preis",
	"filter.price.min": "Min. Preis",
	"filter.provisionGroups.all": "Alle Provisionsgruppen",
	"filter.thisMonth": "Dieser Monat",
	"filter.thisYear": "Dieses Jahr",
	"filter.yearRange": "Letztes Jahr | Letzten {count} Jahre",
	"footer.links.v1signin": "Zu v1 wechseln",
	"intervalType.halfYear": "Halbjährlich",
	"intervalType.monthly": "Monatlich",
	"intervalType.quarterYear": "Vierteljährlich",
	"intervalType.year": "Jährlich",
	"label.accessBlocked": "Zugriff gesperrt",
	"label.accessGranted": "Zugelassen",
	"label.affiliateType.cashback": "Cashback",
	"label.affiliateType.display": "Display-Ads",
	"label.affiliateType.influencer": "Influencer",
	"label.affiliateType.loyalty": "Loyalty",
	"label.affiliateType.other": "Andere",
	"label.affiliateType.priceComparisonEngine": "Preissuchmaschine",
	"label.affiliateType.search": "Search-Ads",
	"label.affiliateType.website": "Website / Content",
	"label.affiliates.count": "Partner",
	"label.amountInSecondsShort": "{0}sek",
	"label.applications.open.total": "Offene Bewerbungen",
	"label.archived": "Archiviert",
	"label.averageCartValue": "⌀ Warenkorb",
	"label.calendarWeekShort": "KW",
	"label.campaignDuration": "Ende der Kampagne",
	"label.campaignName": "Kampagnenname",
	"label.campaignType": "Kampagnentyp",
	"label.campaignVisibility": "Sichtbarkeit einschränken",
	"label.clicks.count": "Klicks",
	"label.columns": "Spalten",
	"label.comissionRate": "Provision-Höhe",
	"label.comissionType": "Provision-Typ",
	"label.commissionAmountRange": "Provision-Höhe",
	"label.comparisonPeriod": "Vergleichszeitraum",
	"label.compensationInEur": "Vergütung (Festbetrag in €)",
	"label.contentLength": "Contentlänge",
	"label.contentTags": "Content-Tags",
	"label.conversion.payout": "Provision",
	"label.conversions": "Conversions",
	"label.conversions.displayMode.single": "Einzelne Conversions",
	"label.conversions.displayMode.weekly": "Wöchentliche Zusammenfassung",
	"label.country": "Land",
	"label.currentPeriod": "Aktueller Zeitraum",
	"label.customDateRange": "Individuell",
	"label.dateRange.comparedTo": "{range} · verglichen mit {comparison}",
	"label.dateRange.since": "Seit {0}",
	"label.dateRange.until": "Bis zum {0}",
	"label.deltaShort": "Δ",
	"label.description": "Beschreibung",
	"label.draft": "Entwurf",
	"label.durationRemaining": "Restlaufzeit",
	"label.emailShort": "E-Mail",
	"label.groupingIntervalOption.date": "Tage",
	"label.groupingIntervalOption.month": "Monate",
	"label.groupingIntervalOption.week": "Wochen",
	"label.heardAboutSource.email": "E-Mail",
	"label.heardAboutSource.google": "Google",
	"label.heardAboutSource.notSpecified": "Keine Angabe",
	"label.heardAboutSource.otherSource": "Andere Quelle",
	"label.heardAboutSource.personalInvitation": "Persönliche Einladung",
	"label.heardAboutSource.recommendation": "Empfehlung",
	"label.id": "ID",
	"label.inactive": "Inaktiv",
	"label.individual": "Individuell wählen",
	"label.language": "Sprache",
	"label.languages": "Sprachen",
	"label.lastMonths": "der letzten {0} Monate",
	"label.lensGrouping.country": "Nach Land",
	"label.lensGrouping.group": "Nach Provisionsgruppe",
	"label.lensGrouping.publisher": "Alle Partner",
	"label.month": "Monat",
	"label.netSumRange": "Umsatz (Netto)",
	"label.networkAccess": "Netzwerkzugriff",
	"label.noProgramme": "Ohne Programm",
	"label.noSales": "Kein Umsatz",
	"label.noVisibilitySettingsYet": "Deine Kampagne ist unsichtbar",
	"label.openApplications": "Bewerbungen",
	"label.openApplicationsWithCount": "1 Bewerbung | {count} Bewerbungen",
	"label.openSubmissionsWithCount": "1 Einsendung | {count} Einsendungen",
	"label.others": "Sonstige",
	"label.partner": "Partner",
	"label.payoutFrom": "ab {value}",
	"label.payoutRange": "Auszahlungsbetrag",
	"label.performance": "Performance",
	"label.performanceIndex": "Performance Index",
	"label.period": "Zeitraum",
	"label.platform": "Plattform",
	"label.platforms": "Plattformen",
	"label.previousPeriod": "Vorheriger Zeitraum",
	"label.primaryPlatform": "Primärplattform",
	"label.programme": "Programm",
	"label.programmeAffiliation": "Programmzugehörigkeit",
	"label.programmeApplicationState": "Bewerbungsstatus",
	"label.provisionGroup": "Provisionsgruppe",
	"label.publisherId": "Publisher ID",
	"label.publisherIdShort": "ID",
	"label.rankShort": "#",
	"label.reach": "Reichweite",
	"label.reach.none": "Keine",
	"label.referrerBonus": "Referrer-Bonus",
	"label.rejectionReason": "Ablehnungsgrund",
	"label.requirements.minSubscribers": "Minimum Reichweite",
	"label.requirements.targetCountry": "Zielland / Zielländer",
	"label.revenue": "Umsatz",
	"label.revenueLastDays": "Umsatz in den letzten {0} Tagen",
	"label.saleAmountRange": "Bestellwert",
	"label.salesValue": "Sales Value",
	"label.salesValueShare": "Anteil Sales Value",
	"label.search": "Suchen...",
	"label.searchScope.ariaLabel": "Suchfeld auswählen",
	"label.searchScope.company": "Firma",
	"label.searchScope.conversionId": "Conversion ID",
	"label.searchScope.email": "E-Mail",
	"label.searchScope.handle": "Kanalname",
	"label.searchScope.ignoredTerms": "Ignoriert, weil kein gültiger Wert für {label}: {terms}",
	"label.searchScope.invoiceNumber": "Gutschriftnummer",
	"label.searchScope.name": "Name",
	"label.searchScope.orderNumber": "Bestellnummer",
	"label.searchScope.placeholder": "Nach {label} suchen...",
	"label.searchScope.publisherId": "Publisher ID",
	"label.searchScope.subId1": "Sub ID 1",
	"label.searchScope.subId2": "Sub ID 2",
	"label.selectComparisonPeriod": "Vergleichszeitraum auswählen",
	"label.selectPeriod": "Zeitraum auswählen",
	"label.selected": "{0} ausgewählt",
	"label.sortAscending": "Aufsteigend sortiert",
	"label.sortByLong": "Sortieren nach:",
	"label.sortDescending": "Absteigend sortiert",
	"label.thumbnail.format": "Format",
	"label.thumbnail.size": "Größe",
	"label.thumbnail.size.atLeast": "mindestens {0}",
	"label.totalCreators": "Creator",
	"label.totalParticipants": "Teilnehmer",
	"label.weekOfDate": "Woche vom {0}",
	"label.withProgramme": "Mit Programm",
	"label.withSales": "Mit Umsatz",
	"label.withoutPending": "Bestätigt",
	"label.workInProgress": "In Arbeit",
	"label.yAxisScaleOption.linear": "Linear",
	"label.yAxisScaleOption.logarithmic": "Logarithmisch",
	"label.year": "Jahr",
	"label.yourCreativeLink": "Creative Link",
	"label.yourLink": "Personalisierter Tracking-Link",
	"label.yourPublisherId": "Affiliate ID (affid)",
	"label.yoy": "YoY",
	"language.english": "Englisch",
	"language.german": "Deutsch",
	"link.imprint": "https://clickfire.io/de/impressum",
	"link.privacyPolicy": "https://clickfire.io/de/datenschutz",
	"link.tos": "https://clickfire.io/de/agb",
	"modal.billingData.label.city": "Stadt",
	"modal.billingData.label.companyName": "Firma (optional)",
	"modal.billingData.label.country": "Land",
	"modal.billingData.label.firstName": "Vorname",
	"modal.billingData.label.lastName": "Nachname",
	"modal.billingData.label.postalCode": "PLZ",
	"modal.billingData.label.street": "Straße",
	"modal.campaignApplicationSuccess.title": "Bewerbung erfolgreich abgeschickt",
	"modal.campaignCreated.draft.title": "Entwurf erfolgreich erstellt!",
	"modal.campaignCreated.title": "Kampagne erfolgreich erstellt!",
	"modal.cropImage.button.cancel": "Abbrechen",
	"modal.cropImage.button.confirm": "Anwenden",
	"modal.cropImage.button.reset": "Zurücksetzen",
	"modal.cropImage.title": "Bild bearbeiten",
	"modal.deleteCampaign.description": "Bist du dir sicher, dass du diese Kampagne löschen möchtest?",
	"modal.deleteCampaign.title": "Entwurf löschen",
	"modal.downloadCsv.badge.hasAnyFilterActive": "Filter aktiv",
	"modal.downloadCsv.description": "Du kannst dir für deinen Report eine CSV erstellen lassen. Dabei werden alle zurzeit aktivierten Filter angewandt. Je nach Datenmenge kann die Erstellung einen Moment dauern.",
	"modal.downloadCsv.title": "Report als CSV herunterladen",
	"modal.mfaSetup.description": "Scanne den QR Code mit deiner Authentifizierungs-App oder gib den Code manuell ein. Nach erfolgreicher Einrichtung musst du den PIN direkt hier eingeben um den Vorgang abzuschließen.",
	"modal.mfaSetup.factorSecretCode.description": "Benutze diesen Code, wenn du Schwierigkeiten mit dem QR Code hast",
	"modal.mfaSetup.factorSecretCode.title": "Secret Code",
	"modal.mfaSetup.title": "Multi-Faktor-Authentifizierung einrichten",
	"modal.newPassword.label.password": "Neues Passwort",
	"modal.newPassword.label.passwordConfirm": "Neues Passwort bestätigen",
	"modal.newSegment.button.cancel": "Abbrechen",
	"modal.newSegment.button.confirm": "Erstellen",
	"modal.newSegment.description": "Wie möchtest du die neue Creatorgruppe nennen?",
	"modal.newSegment.input.placeholder": "Gib deiner neuen Creatorgruppe einen Namen",
	"modal.newSegment.title": "Neue Creatorgruppe erstellen",
	"modal.outdatedBrowser.button": "Meldung ignorieren",
	"modal.outdatedBrowser.description": "Du benutzt eine alte Browserversion, die Clickfire leider nicht mehr unterstützt. Damit du unsere App ohne Probleme verwenden kannst, führe bitte ein Update auf eine aktuelle Version durch.",
	"modal.outdatedBrowser.title": "Dein Browser ist veraltet",
	"modal.paymentInformation.label.accountHolder": "Kontoinhaber",
	"modal.paymentInformation.label.bankName": "Name der Bank",
	"modal.paymentInformation.label.bic": "BIC",
	"modal.paymentInformation.label.emailAdress": "E-Mail-Adresse",
	"modal.paymentInformation.label.iban": "IBAN",
	"modal.paymentInformation.label.paymentType": "Zahlungsart",
	"modal.programmeApplication.button.confirm": "Okay, verstanden!",
	"modal.programmeApplication.rejected.note": "Wenn du zu einem späteren Zeitpunkt die Bedingung erfüllen solltest kannst du dich beim Support melden, damit du dich erneut auf das Programm bewerben kannst",
	"modal.programmeApplication.rejected.reason.general.title": "Deine Bewerbung auf \"{0}\" wurde abgelehnt.",
	"modal.programmeApplication.rejected.reason.policy.title": "Deine Bewerbung auf \"{0}\" wurde aufgrund der Affiliate Policy abgelehnt.",
	"modal.programmeApplication.rejected.reason.reach.title": "Deine Bewerbung auf \"{0}\" wurde wegen zu geringer Reichweite abgelehnt.",
	"modal.programmeApplication.rejected.reason.topic.title": "Deine Bewerbung auf \"{0}\" wurde wegen verfehlter Thematik abgelehnt.",
	"modal.removeMfaConfirmation.cancelLabel": "Abbrechen",
	"modal.removeMfaConfirmation.confirmLabel": "Okay",
	"modal.removeMfaConfirmation.description": "Bist du dir sicher, dass du deine Authentifizierung-App entfernen möchtest?",
	"modal.removeMfaConfirmation.title": "Authentifizierung-App entfernen",
	"modal.segmentCreatorPreview.title": "Alle Creator vom Segment \"{0}\"",
	"modal.selectProvisionGroup.button.confirm": "Zugriff gewähren",
	"modal.selectProvisionGroup.description": "Um Programmzugang zu gewähren, muss eine Provisionsgruppe hinterlegt sein. Bitte wähle eine Provisionsgruppe aus.",
	"modal.selectProvisionGroup.placeholder": "Provisionsgruppe auswählen",
	"modal.selectProvisionGroup.title": "Provisionsgruppe erforderlich",
	"modal.selectRejectionReasons.title": "Ablehnungsgrund",
	"modal.submissionLinks.title": "Einsendungen von {0}",
	"modal.submissions.approved.subtitle": "Die Überweisung der Gutschrift geschieht mit dem nächsten Auszahlungszyklus",
	"modal.submissions.approved.title": "Deine Einsendung wurde angenommen",
	"modal.submissions.button.addContentUrl": "URL hinzufügen",
	"modal.submissions.exceeded.subtitle": "Die Kampagne ist leider nicht mehr aktiv.",
	"modal.submissions.exceeded.title": "Einsendung leider nicht mehr möglich",
	"modal.submissions.goToFaq": "Hilfe benötigt? {link}",
	"modal.submissions.goToFaq.link": "Hier gehts zum FAQ",
	"modal.submissions.label.confirmTos": "Mit deiner Zustimmung zu den AGB begründest du einen Vertrag zwischen dir, {merchant} und Clickfire. {link}",
	"modal.submissions.label.confirmTos.link": "Details siehe AGB",
	"modal.submissions.label.contentUrl": "Content-URL",
	"modal.submissions.label.videoUrl": "Video-URL",
	"modal.submissions.missing.subtitle": "Bitte beachte dabei die Vorgaben der Kampagne",
	"modal.submissions.missing.title": "Wir freuen uns auf deinen Content!",
	"modal.submissions.rejected.subtitle": "Du kannst eine neue Einsendung abschicken, wenn du deinen Inhalt angepasst hast.",
	"modal.submissions.rejected.title": "Deine Einsendung wurde abgelehnt",
	"modal.submissions.submitted.subtitle": "Die Bearbeitung deiner Einsendungen dauert durchschnittlich 3-5 Tage",
	"modal.submissions.submitted.title": "Deine Einsendung wird bearbeitet",
	"modal.success.subtitle.splitOne": "Wir bitten um Geduld bis",
	"modal.success.subtitle.splitTwo": " das Video geprüft hat. In der Zwischenzeit kannst du auch den Status deiner Einsendung verfolgen.",
	"modal.success.title": "Vielen Dank für deine Einsendung",
	"modal.tiptaplink.button.delete": "Löschen",
	"modal.tiptaplink.button.submit": "Speichern",
	"modal.tiptaplink.title": "Link hinterlegen",
	"modal.uncopiedLink.cancelLabel": "Auf Seite bleiben",
	"modal.uncopiedLink.confirmLabel": "Programm Übersicht",
	"modal.uncopiedLink.description": "Du hast noch keinen Link kopiert!",
	"modal.uncopiedLink.title": "Möchtest du wirklich die Seite verlassen?",
	"modal.unsavedChanges.cancelLabel": "Zurück",
	"modal.unsavedChanges.confirmLabel": "Nicht speichern",
	"modal.unsavedChanges.description": "Bist du sicher, dass du diesen Bereich verlassen möchtest, ohne zu speichern?",
	"modal.unsavedChanges.title": "Warnung: Ungespeicherte Änderungen",
	"note.aboutConversionsData": "Abgelehnte Conversions werden nicht angezeigt",
	"note.aboutNewReportDataLatency": "Es kann bis zu 5 Minuten dauern bis neue Daten dargestellt werden",
	"page.account.applicationAndChannels.title": "Bewerbungsdaten & Kanäle",
	"page.account.heading": "Dein Profil",
	"page.account.merchant.title": "Bewerbungsdaten",
	"page.account.password.section.changePassword.title": "Passwort ändern",
	"page.account.password.section.mfa.description": "Die Einrichtung einer Authentifizierung-App ist eine gute Möglichkeit, deinem Clickfire-Account eine zusätzliche Sicherheitsebene hinzuzufügen, um sicherzustellen, dass nur du dich einloggen kannst.",
	"page.account.password.section.mfa.title": "Multi-Faktor-Authentifizierung",
	"page.account.payment.section.payment.title": "Zahlungsinformationen",
	"page.account.payment.section.publisherData.title": "Rechnungsdaten",
	"page.account.payment.title": "Rechnungs- & Zahlungsdaten",
	"page.account.socialMedia.title": "Kanäle",
	"page.account.title": "Profileinstellungen",
	"page.account.uploadAvatar.requirements1": "min. 500x500px",
	"page.account.uploadAvatar.requirements2": "format: png oder jpg",
	"page.account.widget.passwordAndSecurity.title": "Passwort & Sicherheit",
	"page.admin.affiliate.misc.customTrackingParameters": "Benutzerdefinierte Tracking-Parameter",
	"page.admin.affiliate.misc.emailAddressInvoice": "E-Mail-Adresse für Gutschriften",
	"page.admin.affiliate.misc.emailNotificationOnInvoice": "E-Mail-Benachrichtigung bei Gutschrift",
	"page.admin.affiliate.misc.emailNotificationOnSale": "E-Mail-Benachrichtigung bei Verkauf",
	"page.admin.affiliate.misc.language": "Sprache für E-Mail Kommunikation",
	"page.admin.affiliate.misc.rejectConversions": "Alle Conversions ablehnen",
	"page.admin.affiliate.misc.skipInvoiceCreation": "Rechnungserstellung überspringen",
	"page.admin.affiliate.misc.skipSepaExport": "SEPA-Export überspringen",
	"page.admin.affiliate.misc.smallBusinessRegulationAffected": "Kleinunternehmerregelung",
	"page.admin.affiliate.misc.taxConfirmationSupplied": "Steuerbestätigung hinterlegt",
	"page.admin.affiliate.notFound": "Affiliate nicht gefunden",
	"page.admin.affiliate.unsavedChanges": "Du hast ungespeicherte Änderungen",
	"page.admin.affiliate.widget.applicationData.title": "Bewerbungsdaten",
	"page.admin.affiliate.widget.billingAndTaxes.title": "Abrechnung & Steuern",
	"page.admin.affiliate.widget.billingData.title": "Rechnungsdaten",
	"page.admin.affiliate.widget.channels.title": "Kanäle",
	"page.admin.affiliate.widget.creatorProfile.title": "Creator Profil",
	"page.admin.affiliate.widget.individualPayout.noAccess": "Der individuelle Payout kann erst konfiguriert werden, wenn der User Zugriff auf dieses Programm hat.",
	"page.admin.affiliate.widget.individualPayout.noProvisionGroup": "Ein individueller Payout kann erst gesetzt werden, wenn eine Provisionsgruppe hinterlegt wurde.",
	"page.admin.affiliate.widget.individualPayout.override.description": "Überschreibt den Standardpayout der hinterlegten Provisionsgruppe für dieses Programm.",
	"page.admin.affiliate.widget.individualPayout.override.label": "Individuellen Payout für dieses Programm überschreiben",
	"page.admin.affiliate.widget.individualPayout.title": "Individueller Payout",
	"page.admin.affiliate.widget.masterData.title": "Stammdaten",
	"page.admin.affiliate.widget.misc.title": "Sonstiges",
	"page.admin.affiliate.widget.paymentInfo.title": "Zahlungsinformationen",
	"page.admin.affiliate.widget.pecHistory.omitRejected": "Abgelehnte Bewerbungen ausblenden",
	"page.admin.affiliate.widget.pecHistory.title": "Kampagnenübersicht",
	"page.admin.affiliate.widget.productFeedRegistrations.title": "Product Feed Anmeldungen",
	"page.admin.affiliate.widget.programmeApplications.title": "Programm- und Kampagnenzulassung",
	"page.admin.affiliate.widget.programmes.button.grantAccess": "Programmzugang gewähren",
	"page.admin.affiliate.widget.programmes.button.hold": "Zurückstellen",
	"page.admin.affiliate.widget.programmes.button.resume": "Reaktivieren",
	"page.admin.affiliate.widget.programmes.button.revokeAccess": "Programmzugang entziehen",
	"page.admin.affiliate.widget.provisionGroups.placeholder": "Provisionsgruppe auswählen",
	"page.admin.affiliate.widget.provisionGroups.title": "Provisionsgruppe",
	"page.admin.affiliate.widget.urlReferrer.title": "URL Referrer",
	"page.admin.applications.history.title": "Bewerbungshistorie",
	"page.admin.applications.label.onlyShowOpenApplications": "Zurückgestellte Bewerbungen ausblenden",
	"page.admin.applications.title": "Bewerbungsübersicht",
	"page.admin.campaign.applications.title": "Bewerbungen",
	"page.admin.campaign.apply.card.label.codeDuration": "Gültigkeit des Codes",
	"page.admin.campaign.apply.card.label.videoCode": "Video-Code",
	"page.admin.campaign.apply.steps.stepFive.alert.description": "Sofern du möchtest, dass der autorisierte Post nur in TikTok-Anzeigen, nicht aber im „Für dich“-Feed, im Follower-Feed, auf deiner Profilseite, in den Suchergebnissen und in der Playlist erscheint, kannst du in den Anzeigeneinstellungen den Schalter „Nur in Anzeigen ausliefern“ aktivieren. Diese Funktion ist allerdings erst ab TikTok-Version 21.3 verfügbar.",
	"page.admin.campaign.apply.steps.stepFive.alert.title": "Hinweis",
	"page.admin.campaign.apply.steps.stepFive.text": "Füge den Code in unsere dafür vorgesehene Eingabemaske ein.",
	"page.admin.campaign.apply.steps.stepFive.title": "Schritt 5:",
	"page.admin.campaign.apply.steps.stepFour.listItemOne": "Schalte die \"Anchor Authorization\" frei, um uns die Möglichkeit zu geben einen Link an dein Video anzufügen. Dieser Schritt ist optional.",
	"page.admin.campaign.apply.steps.stepFour.text": "Schalte die \"Anchor Authorization\" frei.",
	"page.admin.campaign.apply.steps.stepFour.title": "Schritt 4:",
	"page.admin.campaign.apply.steps.stepOne.text": "Nimm ein Video entsprechend der genannten Anforderungen auf und lade es als TikTok hoch.",
	"page.admin.campaign.apply.steps.stepOne.title": "Schritt 1:",
	"page.admin.campaign.apply.steps.stepThree.alert.description": "Du kannst in dieser Ansicht den generierten Code nachträglich nochmal verlängern.",
	"page.admin.campaign.apply.steps.stepThree.alert.title": "Hinweis",
	"page.admin.campaign.apply.steps.stepThree.listItemOne": "Wähle die gewünschte Autorisierungsdauer aus und klicke auf \"Autorisieren\". Wir empfehlen mind. 30 Tage, damit ausreichend Zeit zur Verfügung steht, dein Video als Ad zu buchen.",
	"page.admin.campaign.apply.steps.stepThree.listItemThree": "Kopiere abschließend den Video-Code, indem du auf \"Verwalten\" klickst.",
	"page.admin.campaign.apply.steps.stepThree.listItemTwo": "Klicke nun auf \"Generieren\" und anschließend auf \"Speichern\".",
	"page.admin.campaign.apply.steps.stepThree.text": "Generiere den Video-Code.",
	"page.admin.campaign.apply.steps.stepThree.title": "Schritt 3:",
	"page.admin.campaign.apply.steps.stepTwo.listItemOne": "Öffne das zu autorisierende TikTok-Video.",
	"page.admin.campaign.apply.steps.stepTwo.listItemThree": "Aktiviere den Schalter “Anzeigenautorisierung” und stimme den Geschäftsbedingungen zu.",
	"page.admin.campaign.apply.steps.stepTwo.listItemTwo": "Klicke unten rechts auf die drei Punkte um das Menü zu öffnen und anschließend auf “Anzeigeeinstellungen”.",
	"page.admin.campaign.apply.steps.stepTwo.text": "Autorisiere das Video in der TikTok-App für die Nutzung zu Werbezwecken.",
	"page.admin.campaign.apply.steps.stepTwo.title": "Schritt 2:",
	"page.admin.campaign.apply.steps.title": "Wie generiere ich einen Video-Code?",
	"page.admin.campaign.apply.title.partOne": "Video für",
	"page.admin.campaign.apply.title.partTwo": "einsenden",
	"page.admin.campaign.archived": "Archiviert",
	"page.admin.campaign.description": "Beschreibung",
	"page.admin.campaign.noCampaigns.subtitle": "Erstelle eine Kampagne, damit deine Affiliates Content erstellen können.",
	"page.admin.campaign.noCampaigns.title": "Keine aktiven Kampagnen",
	"page.admin.campaign.notFound": "Kampagne nicht gefunden",
	"page.admin.campaign.requirements": "Anforderungen",
	"page.admin.campaign.submissions.backToCampaign": "Zurück zur Kampagne",
	"page.admin.campaign.submissions.title": "Einsendungen",
	"page.admin.campaign.submissions.transimittals": "Einsendungen",
	"page.admin.campaign.videoRequirements": "Anforderungen an das Video",
	"page.admin.campaigns.active.title": "Aktive Kampagnen",
	"page.admin.campaigns.alert.disallowAdvancedEditing": "Es haben sich bereits Affiliates auf deine Kampagne beworben. Es können daher nicht alle Angaben bearbeitet werden.",
	"page.admin.campaigns.button.addRequirement": "Anforderung hinzufügen",
	"page.admin.campaigns.button.addRestriction": "Verbote hinzufügen",
	"page.admin.campaigns.button.createCampaign": "Kampagne erstellen",
	"page.admin.campaigns.createNewCampaign": "Neue Kampagne erstellen",
	"page.admin.campaigns.editCampaign": "Kampagne bearbeiten",
	"page.admin.campaigns.label.campaignTitle": "Titel der Kampagne",
	"page.admin.campaigns.label.compensationInEuro": "Vergütung (in €)",
	"page.admin.campaigns.label.description": "Beschreibung",
	"page.admin.campaigns.label.endOfCampaign": "Ende der Kampagne",
	"page.admin.campaigns.label.noLanguages": "Füge jetzt die erste Sprache für deine neue Kampagne hinzu",
	"page.admin.campaigns.label.thumbnail": "Thumbnail",
	"page.admin.campaigns.label.uProductOrCategory": "Produkt/Kategorie",
	"page.admin.campaigns.newCampaign": "Neue Kampagne",
	"page.admin.campaigns.plusCreateCampaign": "+ Kampagne erstellen",
	"page.admin.dashboard.cards.activeCampaigns.linkLabel": "aktive Kampagnen anzeigen",
	"page.admin.dashboard.cards.activeCampaigns.title": "Aktive Kampagnen",
	"page.admin.dashboard.cards.openSubmission.linkLabel": "Einsendungen anzeigen",
	"page.admin.dashboard.cards.openSubmission.title": "Offene Einsendungen",
	"page.admin.dashboard.cards.payouts.linkLabel": "vergangene Auszahlungen anzeigen",
	"page.admin.dashboard.cards.payouts.title": "Offenes Guthaben",
	"page.admin.dashboard.dataFreshness": "Die Daten werden alle 6 Stunden aktualisiert. Letzte Aktualisierung vor ~{elapsed}.",
	"page.admin.dashboard.headline": "{merchant} Dashboard",
	"page.admin.dashboard.widget.campaignTodos.label.openApplications": "Bewerbungen offen",
	"page.admin.dashboard.widget.campaignTodos.label.openSubmissions": "Einsendungen",
	"page.admin.dashboard.widget.campaignTodos.title": "Kampagnen-To-Dos",
	"page.admin.dashboard.widget.networkActivity.label.active": "Aktiv mit Conversions",
	"page.admin.dashboard.widget.networkActivity.label.newPartnersWithoutClick": "Neue Partner ohne Klick",
	"page.admin.dashboard.widget.networkActivity.label.newPartnersWithoutConversion": "Neue Partner ohne Conversion",
	"page.admin.dashboard.widget.networkActivity.title": "Netzwerk-Aktivität",
	"page.admin.dashboard.widget.networkByCountry.title": "Netzwerk nach Land",
	"page.admin.dashboard.widget.programmeTodos.label.openApplications": "Bewerbungen offen",
	"page.admin.dashboard.widget.programmeTodos.label.openConversions": "Conversions in Prüfung",
	"page.admin.dashboard.widget.programmeTodos.title": "Programm-To-Dos",
	"page.admin.dashboard.widget.provisionGroups.title": "Provisionsgruppen",
	"page.admin.dashboard.widget.topPerformers.label.allCountries": "Alle Länder",
	"page.admin.dashboard.widget.topPerformers.label.allProvisionGroups": "Alle Provisionsgruppen",
	"page.admin.dashboard.widget.topPerformers.label.byCountry": "Nach Land",
	"page.admin.dashboard.widget.topPerformers.label.byProvisionGroup": "Nach Provisionsgruppe",
	"page.admin.dashboard.widget.topPerformers.title": "Top-Performer",
	"page.admin.domains.empty.description": "Du hast alles abgearbeitet! Sobald es neue Registrierungen gibt, werden sie dir hier angezeigt.",
	"page.admin.domains.empty.title": "Keine Domainregistrierungen vorhanden",
	"page.admin.domains.openRegistrations": "Offene Domain Registrierungen",
	"page.admin.domains.title": "Domains",
	"page.admin.merchant.viewTitle": "Hallo",
	"page.admin.merchants.availableMerchants": "Verfügbare Merchants",
	"page.admin.merchants.dashboard.title": "Merchant Dashboard",
	"page.admin.merchants.submissions.title": "Einsendung von",
	"page.admin.merchants.title": "Admin Merchant Auswahl",
	"page.admin.partnerReport.title": "Netzwerk Report",
	"page.admin.payouts.payouts": "Auszahlungen",
	"page.admin.programmeApplications.history.noApplications.description": "Sobald du eine Bewerbung bearbeitet hast, wird sie hier angezeigt",
	"page.admin.programmeApplications.history.noApplications.title": "Keine Bewerbungen vorhanden",
	"page.admin.programmeApplications.noApplications.description": "Du hast alles abgearbeitet! Sobald es neue Bewerbungen gibt, werden sie dir hier angezeigt",
	"page.admin.programmeApplications.noApplications.title": "Keine Bewerbungen vorhanden",
	"page.admin.segment.addCreators": "Creator hinzufügen",
	"page.admin.segment.goBackToOverview": "Zu allen Creatorgruppen",
	"page.admin.segment.section.campaigns.noCampaigns.description": "Diese Creatorgruppe wird aktuell bei keiner aktiven Kampagne zur eingeschränkten Sichtbarkeit verwendet.",
	"page.admin.segment.section.campaigns.noCampaigns.title": "Keine Kampagnen",
	"page.admin.segment.section.campaigns.title": "Sichtbare Kampagnen",
	"page.admin.segment.section.creators.title": "Nutzerliste",
	"page.admin.segments.createSegment": "Creatorgruppe erstellen",
	"page.admin.segments.noSegments.subtitle": "Erstelle deine erste Gruppe von Creators.",
	"page.admin.segments.noSegments.title": "Keine Creatorgruppen",
	"page.admin.segments.title": "Creatorgruppen",
	"page.admin.submissions.allTransmittals": "Alle Einsendungen",
	"page.admin.submissions.category": "Kategorie",
	"page.admin.submissions.compensation": "Vergütung",
	"page.admin.submissions.dateOfTransmittal": "Datum der Einsendung",
	"page.admin.submissions.helpfulLinks": "Hilfreiche Links",
	"page.admin.submissions.howDoIBookSparkAds": "Wie buche ich Spark Ads im TikTok Ads Manager?",
	"page.admin.submissions.howDoIBookSparkAds.link": "https://ads.tiktok.com/help/article/spark-ads-creation-guide?lang=de#anchor-6",
	"page.admin.submissions.howToGenerateAVideoCode": "Wie generiere ich einen Video-Code?",
	"page.admin.submissions.periodOfValidity": "Gültigkeitsdauer",
	"page.admin.submissions.status": "Status",
	"page.admin.submissions.tikTokCode": "TikTok-Code",
	"page.admin.submissions.transmittalsOf": "Einsendungen von",
	"page.admin.submissions.whyShouldIBookSparkAds": "Warum sollte ich ausgerechnet Spark Ads buchen?",
	"page.admin.submissions.whyShouldIBookSparkAds.link": "https://ads.tiktok.com/help/article/spark-ads?lang=de",
	"page.affiliate.navigation.details": "Payment & Sonstiges",
	"page.affiliate.navigation.overview": "Account Übersicht",
	"page.affiliate.navigation.programmes": "Programme",
	"page.affiliates.filter.showAllChannels.label": "Immer alle Channel anzeigen",
	"page.affiliates.filter.title": "Filteroptionen",
	"page.affiliates.noMatches": "Für deine Suche wurden leider keine passenden Affiliates gefunden",
	"page.affiliates.showChannelInformation.label": "Kanalinformationen anzeigen",
	"page.affiliates.single.title": "Affiliate Details: {0}",
	"page.affiliates.single.widget.overview.title": "Affiliate Partner Übersicht",
	"page.affiliates.title": "Partner Übersicht",
	"page.campaign.archived.title": "Die Kampagne ist abgelaufen und archiviert. Sie kann nicht mehr bearbeitet werden.",
	"page.campaign.draft.title": "Die Kampagne ist nicht veröffentlicht. Es handelt sich um einen Entwurf.",
	"page.campaigns.navigation.applications": "Bewerbungen",
	"page.campaigns.navigation.details": "Kampagnendetails",
	"page.campaigns.navigation.submissions": "Einsendungen",
	"page.campaigns.navigation.visibility": "Sichtbarkeiteinstellungen",
	"page.clickDetailSingle.general.title": "Allgemeine Informationen",
	"page.clickDetailSingle.general.trackingMethod": "Tracking-Methode",
	"page.clickDetailSingle.title": "Klick Details",
	"page.clickDetailSingle.title.notFound": "Klick \"#{0}\" nicht gefunden",
	"page.clickDetailSingle.tracking.browser": "Browser",
	"page.clickDetailSingle.tracking.date": "Datum / Zeit",
	"page.clickDetailSingle.tracking.originalReferrer": "Original Referrer",
	"page.clickDetailSingle.tracking.programmeUrl": "Programm URL",
	"page.clickDetailSingle.tracking.referrer": "Referrer",
	"page.clickDetailSingle.tracking.title": "Tracking",
	"page.clickDetailSingle.tracking.userAgent": "User-Agent",
	"page.clickReport.realtime.subtitle": "Die letzten {0} Clicks der letzten 24 Stunden",
	"page.clickReport.realtime.title": "Echtzeit Clicks",
	"page.clickReport.title": "Click Report",
	"page.confirm.waitForLogin": "Warten auf Login...",
	"page.content.notFound": "Seite nicht gefunden",
	"page.conversionSingle.general.click": "Klick-ID",
	"page.conversionSingle.general.method": "Tracking-Method",
	"page.conversionSingle.general.newCustomer": "Neukunde",
	"page.conversionSingle.general.orderId": "Order-ID",
	"page.conversionSingle.general.programmeType": "Programm-Typ",
	"page.conversionSingle.general.status": "Status",
	"page.conversionSingle.general.title": "Allgemeine Informationen",
	"page.conversionSingle.general.type": "Typ",
	"page.conversionSingle.payout.currency": "Währung",
	"page.conversionSingle.payout.payout": "Provision",
	"page.conversionSingle.payout.saleAmount": "Bestellwert",
	"page.conversionSingle.payout.title": "Provision",
	"page.conversionSingle.title": "Conversion-Details",
	"page.conversionSingle.title.notFound": "Conversion nicht gefunden",
	"page.conversionSingle.transactions.title": "Transaktionsdetails",
	"page.conversions.cards.commissionReport.subtitle": "der letzten {0} Monate",
	"page.conversions.cards.commissionReport.title": "Provision-Übersicht",
	"page.conversions.cards.conversionStatus.subtitle": "der letzten {0} Wochen",
	"page.conversions.cards.conversionStatus.title": "Conversion-Status",
	"page.dashboard.cards.lastInvoice.button": "Rechnung downloaden",
	"page.dashboard.cards.lastInvoice.label": "Rechnungsdatum: {0}",
	"page.dashboard.cards.lastInvoice.title": "Aktuelle Gutschrift",
	"page.dashboard.cards.lastPayout.title": "Zuletzt ausgezahlt",
	"page.dashboard.cards.openPayout.title": "Aktuell offen",
	"page.dashboard.title": "Dashboard",
	"page.error.button.backToHome": "Zurück zur Startseite",
	"page.error.critical.title": "Ein unerwarteter Fehler ist aufgetreten",
	"page.error.notFound.title": "404 - Nicht gefunden",
	"page.error.pageNotFound.title": "Seite nicht gefunden",
	"page.error.support.title": "Ups, da ist etwas schief gegangen",
	"page.error.unexpected.withCode": "Fehlercode: {0}",
	"page.login.label.email": "E-Mail-Adresse",
	"page.login.label.or": "oder",
	"page.login.label.password": "Passwort",
	"page.login.pageTitle": "Login",
	"page.login.subtitle": "in deinem {0} Affiliate Netzwerk",
	"page.login.title": "Hi, schön dich wieder zu sehen 😊",
	"page.loginConfirm.waitingForLogin": "Du wirst angemeldet...",
	"page.logout.waitingForLogout": "Du wirst abgemeldet...",
	"page.merchants.availableMerchants.description": "Du bist für mehrere Merchants registriert. Bitte wähle einen Merchant aus mit dem du fortfahren möchtest.",
	"page.merchants.availableMerchants.title": "Merchant-Auswahl",
	"page.merchants.campaigns.archivedCampaigns": "Archivierte Kampagnen",
	"page.merchants.campaigns.backToOverview": "Zurück zur Übersicht",
	"page.merchants.campaigns.drafts.title": "Entwürfe",
	"page.merchants.campaigns.noCampaigns.subtitle": "Bald wirst du dich hier auf spannende Kampagnen bewerben können. Schau demnächst nochmal vorbei.",
	"page.merchants.campaigns.noCampaigns.title": "Noch keine Kampagnen vorhanden",
	"page.merchants.campaigns.openSubmissions.label": "offene Einsendung",
	"page.merchants.campaigns.openSubmissions.label.plural": "offene Einsendungen",
	"page.merchants.campaigns.showActiveCampaigns.label": "aktive Kampagnen anzeigen",
	"page.merchants.campaigns.showArchivedCampaigns.label": "archivierte Kampagnen anzeigen",
	"page.merchants.campaigns.title": "Verfügbare Kampagnen",
	"page.merchants.conversions.title": "Conversion Report",
	"page.merchants.dashboard.viewTitle": "Willkommen zurück,",
	"page.merchants.noMerchant.description": "Du bist für keinen Merchant registriert. Um mit Clickfire fortzufahren, musst du dich für einen Merchant registrieren. Kehre zurück zu der Webseite von deinem Merchant oder wenden dich an unseren Support.",
	"page.merchants.noMerchant.title": "Kein Merchant gefunden",
	"page.merchants.payouts.title": "Auszahlungen",
	"page.merchants.productReport.title": "Product Report",
	"page.merchants.productWidgetDomains.title": "Domain Übersicht",
	"page.merchants.productWidgetEdit.title": "Widget bearbeiten",
	"page.merchants.productWidgetNew.title": "Widget erstellen",
	"page.merchants.productWidgetPreview.title": "Widget-Vorschau",
	"page.merchants.productWidgets.title": "Product Widgets",
	"page.merchants.programme.applicationStatus": "Bewerbungs Status",
	"page.merchants.programme.canApply.1": "Du bist aktuell nicht für dieses Programm freigeschaltet.",
	"page.merchants.programme.canApply.2": "Bewirb dich jetzt auf dieses Programm.",
	"page.merchants.programme.notFound": "Programm nicht gefunden",
	"page.merchants.programme.yourTrackingLink": "Dein Tracking Link",
	"page.merchants.programmes.backToAvailableProgrammes": "Zurück zu verfügbaren Programmen",
	"page.merchants.programmes.backToYourProgrammeApplications": "Zurück zu deinen Bewerbungen",
	"page.merchants.programmes.backToYourProgrammes": "Zurück zu deinen Programmen",
	"page.merchants.programmes.lookupApplicationsNow": "Bewerbungen ansehen",
	"page.merchants.programmes.lookupAvailableProgrammesNow": "Zu Verfügbare Programme",
	"page.merchants.programmes.noActiveApplicationsFound.1": "Du hast dich noch auf kein Programm beworben.",
	"page.merchants.programmes.noActiveApplicationsFound.2": "Jetzt bei verfügbare Programme nachschauen.",
	"page.merchants.programmes.noAvailableProgrammes": "Kein Verfügbaren Programme vorhanden. D.h der Händler hat keine weiteren Programme oder du bist dafür nicht freigeschalten.",
	"page.merchants.programmes.noProgrammesFound": "Du bist aktuell für kein Programm freigeschaltet.",
	"page.merchants.programmes.title": "Programme",
	"page.merchants.submission.title": "Deine Einsendung für \"{name}\"",
	"page.merchants.submissions.submissions.subtitle": "Schau dir an, welche Kampagnen es gibt und bewirb dich direkt!",
	"page.merchants.submissions.submissions.title": "Noch keine Einsendungen vorhanden",
	"page.merchants.submissions.title": "Einsendungen",
	"page.merchants.videoSubmission.title": "Video einsenden",
	"page.mfa.pageTitle": "Multi-Faktor-Authentifizierung",
	"page.mfa.subtitle": "Bitte gib den Code von deiner Authenticator App ein.",
	"page.mfa.title": "Dein Account ist zusätzlich geschützt",
	"page.newCampaign.step.briefing.description": "Definition der Kampagne und Requirements",
	"page.newCampaign.step.briefing.title": "Schritt 3 – Sprachen & Briefing",
	"page.newCampaign.step.required.description": "Die Basisinformationen für deine Kampagne",
	"page.newCampaign.step.required.title": "Schritt 1 – Kampagne",
	"page.newCampaign.step.setup.description": "Hinterlege ein Thumbnail und bestimmte die Länge, Laufzeit und Zielländer der Kampagne",
	"page.newCampaign.step.setup.title": "Schritt 2 – Setup",
	"page.newPassword.label.password": "Neues Passwort",
	"page.newPassword.label.passwordConfirm": "Neues Passwort bestätigen",
	"page.newPassword.title": "Neues Passwort festlegen",
	"page.productRedirect.demo.subtitle": "Im Demo Modus ist ein Redirect zum Produkt nicht möglich",
	"page.productRedirect.demo.title": "Demo Modus",
	"page.productRedirect.error.notFound.subtitle": "Wir konnten leider keine Produktseite für das Produkt mit der Nummer \"{0}\" finden.",
	"page.productRedirect.error.notFound.title": "Weiterleitung nicht möglich",
	"page.productRedirect.waitForRedirect": "Du wirst zur Produktseite weitergeleitet...",
	"page.productReport.cards.topSeller.subtitle": "der letzten {0} Tage",
	"page.productReport.cards.topSeller.title": "Deine Top-Seller",
	"page.productReport.cards.topSum.subtitle": "der letzten {0} Tage",
	"page.productReport.cards.topSum.title": "Deine Top-Verdiener",
	"page.profile.autoUpdateUserProfile": "Dein Profil wird aktualisiert...",
	"page.programme.promotionLinks.subtitle": "Die größten Programm-Aktionen mit nur einem Klick kopieren!",
	"page.programme.promotionLinks.title": "Personalisierte Promotion-Links",
	"page.programmes.apply.error.subtitle": "Wir konnten deinen Bewerbungsstatus nicht ermitteln oder deine Bewerbung nicht versenden. Falls das Problem weiter besteht, melde dich bitte bei unserem Support.",
	"page.programmes.apply.error.title": "Fehler bei Programm Bewerbung",
	"page.programmes.apply.pageTitle": "Bewerbung",
	"page.programmes.apply.signupPageTitle": "Registrierung",
	"page.programmes.apply.waitForProgram": "Warten auf Programm...",
	"page.resetPassword.subtitle": "Wir haben dir eine E-Mail zum Zurücksetzen deines Passworts an {email} geschickt.",
	"page.resetPassword.title": "Passwort zurücksetzen",
	"page.signup.acceptTosOnSignup": "Mit deiner Registrierung akzeptierst du die Regelungen der {tos}",
	"page.signup.acceptTosOnSignup.tos": "Allgemeinen Geschäftsbedingungen",
	"page.signup.bauhaus.waitlist.greeting": "Liebe Bauhaus-Fans,",
	"page.signup.bauhaus.waitlist.text": "aufgrund der hohen Nachfrage nach unserem Affiliate Programm, können wir aktuell leider keine weiteren Affiliates onboarden. Bitte registriert Euch, um in die Warteliste eingetragen zu werden. Wir werden uns bei Euch melden, sobald wir wieder Kapazitäten haben.",
	"page.signup.confirmYourEmail.subtitle": "Gleich hast du es geschafft!",
	"page.signup.confirmYourEmail.title": "Klasse! Nur noch den Link in deiner E-Mail bestätigen",
	"page.signup.label.email": "E-Mail-Adresse",
	"page.signup.label.firstName": "Vorname",
	"page.signup.label.lastName": "Nachname",
	"page.signup.label.or": "oder",
	"page.signup.label.password": "Passwort",
	"page.signup.pageTitle": "Signup",
	"page.signup.profile.approveSignup": "Signup bestätigen",
	"page.signup.profile.label.firstName": "Vorname",
	"page.signup.profile.label.lastName": "Nachname",
	"page.signup.profile.subtitle": "Damit wir weitermachen können, müssen wir dich noch näher kennenlernen.",
	"page.signup.profile.title": "Bestätige dein Profil",
	"page.signup.subtitle.withMerchant": "in deinem {merchant} Affiliate Netzwerk!",
	"page.signup.subtitle.withoutMerchant": "Registriere dich jetzt bei Clickfire!",
	"page.signup.thomann.requirement.1": "Mind. 500 Unique Visits pro Tag bei Webseiten",
	"page.signup.thomann.requirement.2": "Mind. 5.000 Follower auf Social-Media-Kanälen",
	"page.signup.thomann.requirement.readMore.link": "hier",
	"page.signup.thomann.requirement.readMore.text": "Weitere Informationen dazu findest du unter {link}.",
	"page.signup.thomann.requirement.title": "Bitte berücksichtige bei deiner Registrierung, dass folgende Mindestanforderungen erfüllt sein müssen:",
	"page.signup.title": "Herzlich Willkommen 😊",
	"page.signupConfirm.waitingForConfirmation": "Registrierung wird abgeschlossen...",
	"page.signupMigration.otp.subtitle": "Wir haben dir einen Bestätigungscode an deine E-Mail Adresse geschickt. Bitte gib diesen hier ein.",
	"page.signupMigration.otp.title": "Gib den Bestätigungscode ein",
	"page.signupMigration.setPassword.subtitle": "Sobald du ein Passwort vergeben hast, kannst du dich ganz normal über den regulären Clickfire v2 Login anmelden",
	"page.signupMigration.setPassword.title": "Password speichern",
	"page.signupMigration.subtitle": "Damit wir dich zuordnen können benötigen wir deine E-Mail Adresse.",
	"page.signupMigration.title": "Schön dich im neuen Clickfire zu sehen!",
	"page.v1redirect.waitingForRedirect": "Du wirst weitergeleitet...",
	"page.v1signin.waitingForLogin": "Du wirst angemeldet...",
	"paymentType.intlTransfer": "SWIFT",
	"paymentType.paypal": "Paypal",
	"paymentType.sepa": "Überweisung / SEPA",
	"placeholder.password": "Passwort eingeben",
	"popover.application.doubleCheck": "Aktion bestätigen:",
	"popover.embedCodeCopiedSuccessfully": "Code kopiert!",
	"popover.linkCopiedSuccessfully": "Link kopiert!",
	"popover.segmentCreators.doubleCheck": "Creator aus Gruppe entfernen?",
	"productWidget.copy.embedDescription": "Diesen Codeblock platzierst du an der Stelle, an der du das Widget anzeigen möchtest. Zusammen mit dem Script-Tag wird dort dein konfiguriertes Widget geladen.",
	"productWidget.copy.embedLabel": "Widget-Code",
	"productWidget.copy.scriptDescription": "Füge diesen Script-Tag im <head> deiner Seite ein. Er wird benötigt, damit das Widget geladen und mit Inhalt gefüllt werden kann.",
	"productWidget.copy.scriptLabel": "Script-Tag",
	"productWidget.copy.title": "Widget einbinden",
	"productWidget.create.button": "Widget erstellen",
	"productWidget.delete.cancelLabel": "Abbrechen",
	"productWidget.delete.confirmDescription": "Du kannst das Widget trotzdem weiterhin auf deiner Webseite verwenden, kannst aber keine Auswertungen mehr machen.",
	"productWidget.delete.confirmLabel": "Löschen",
	"productWidget.delete.confirmTitle": "Möchtest du das Product Widget „{name}“ wirklich löschen?",
	"productWidget.delete.error": "Fehler beim Löschen des Product Widgets „{name}“.",
	"productWidget.delete.success": "Product Widget „{name}“ wurde gelöscht.",
	"productWidget.domain.admin.actionError": "Aktion konnte nicht ausgeführt werden. Bitte versuche es erneut.",
	"productWidget.domain.admin.publisherId": "ID: {id}",
	"productWidget.domain.admin.registrationFor": "Domain Registrierung für",
	"productWidget.domain.delete.cancelLabel": "Abbrechen",
	"productWidget.domain.delete.confirmDescription": "Nach dem Löschen funktionieren deine Product Widgets auf dieser Domain nicht mehr.",
	"productWidget.domain.delete.confirmLabel": "Löschen",
	"productWidget.domain.delete.confirmTitle": "Möchtest du die Domain „{name}“ wirklich löschen?",
	"productWidget.domain.delete.error": "{domain} konnte nicht gelöscht werden. Bitte versuche es erneut.",
	"productWidget.domain.delete.success": "{domain} wurde gelöscht.",
	"productWidget.domain.form.invalidDomain": "Bitte gib eine gültige Domain ein (z. B. deine-seite.de).",
	"productWidget.domain.status.accepted": "Akzeptiert",
	"productWidget.domain.status.rejected": "Abgelehnt",
	"productWidget.domain.status.submitted": "Eingereicht",
	"productWidget.domain.submit.button": "Domain einreichen",
	"productWidget.domain.submit.error": "Die Domain konnte nicht eingereicht werden. Bitte versuche es erneut.",
	"productWidget.domain.submit.placeholder": "deine-seite.de",
	"productWidget.domain.submit.success": "{domain} wurde zur Prüfung eingereicht.",
	"productWidget.domain.submit.validationError": "Bitte gib eine gültige Domain ein.",
	"productWidget.domain.table.delete": "Domain löschen",
	"productWidget.domain.table.empty": "Noch keine Domains eingereicht.",
	"productWidget.domain.table.name": "Domain Name",
	"productWidget.domain.table.status": "Status",
	"productWidget.domain.table.submittedAt": "Eingereicht am",
	"productWidget.domainPending.description": "Super! Du hast eine Domain hinterlegt. Du kannst Product Widgets bereits erstellen, aber diese werden technisch erst auf deiner Webseite funktionieren, wenn die Domain von uns freigegeben wurde.",
	"productWidget.domainRejected.description": "Leider wurde deine Domain abgelehnt. Um die Product Widgets nutzen zu können, benötigst du mindestens eine aktive Domain. Du kannst jetzt {domainLink} oder dich bei Fragen an unser {supportLink} wenden.",
	"productWidget.domainRejected.domainLink": "eine andere Domain einreichen",
	"productWidget.domainRejected.supportLink": "Support-Team",
	"productWidget.duplicate.copySuffix": " (Kopie)",
	"productWidget.edit.configuratorTitle": "Widget bearbeiten",
	"productWidget.edit.notFound": "Dieses Product Widget wurde nicht gefunden.",
	"productWidget.edit.saveButton": "Änderungen speichern",
	"productWidget.edit.saveError": "Änderungen konnten nicht gespeichert werden. Bitte versuche es erneut.",
	"productWidget.edit.saveSuccess": "Änderungen wurden gespeichert.",
	"productWidget.empty.features.catalog.description": "Einfach Produkte über Name oder Nummer suchen und ins Widget einbinden.",
	"productWidget.empty.features.catalog.title": "Eingebundener Produktkatalog",
	"productWidget.empty.features.noCode.description": "Deine eigenen kostenlosen Web-Ads in wenigen Minuten ohne Kenntnisse live nehmen.",
	"productWidget.empty.features.noCode.title": "Keine Webkenntnisse notwendig",
	"productWidget.empty.features.responsive.description": "Ist auf den gängigen Gerätetypen wie Mobile, Tablet und Desktop optimiert.",
	"productWidget.empty.features.responsive.title": "Responsive Design",
	"productWidget.empty.headline": "Mit Product Widgets zu deinem visuellen Product Placement",
	"productWidget.empty.modalSubtitle": "Nach Eingabe der Domain kannst du dein erstes Product Widget erstellen.",
	"productWidget.empty.notApproved": "Du musst für mindestens ein Programm zugelassen sein, um Product Widgets nutzen zu können.",
	"productWidget.empty.subtitle": "Mit Product Widgets kannst du schnell und komfortabel visuelle Ads auf deiner Website schalten. Du musst nur deine Domain von unseren Affiliate-Managern freigeben lassen.",
	"productWidget.new.backToOverview": "Zur Widget Übersicht",
	"productWidget.new.brandPlaceholder": "Nach Marke…",
	"productWidget.new.buttonLabelDescription": "Steht auf dem Button jedes Produkts, z. B. „Jetzt im Shop ansehen“. Ohne Eingabe wird ein Standardtext verwendet.",
	"productWidget.new.buttonLabelShortDescription": "Ersetzt den Button-Text, wenn das Widget schmal dargestellt wird, z. B. auf Smartphones.",
	"productWidget.new.categoryPlaceholder": "Nach Kategorie…",
	"productWidget.new.configuratorTitle": "Widget Konfigurator",
	"productWidget.new.createButton": "Product Widget erstellen",
	"productWidget.new.errors.name": "Bitte gib einen Widget-Namen ein.",
	"productWidget.new.errors.productCount": "Bitte lege die Anzahl der Produkte fest.",
	"productWidget.new.errors.products": "Bitte füge mindestens ein Produkt hinzu.",
	"productWidget.new.errors.programme": "Bitte wähle eine Programm-ID aus.",
	"productWidget.new.errors.shop": "Bitte wähle einen Shop aus.",
	"productWidget.new.errors.title": "Bitte korrigiere folgende Angaben:",
	"productWidget.new.fields.buttonLabel": "Button-Text",
	"productWidget.new.fields.buttonLabelShort": "Button-Text (kurz)",
	"productWidget.new.fields.layout": "Layout",
	"productWidget.new.fields.name": "Widget Name",
	"productWidget.new.fields.payoutInfo": "Vergütungs-Info",
	"productWidget.new.fields.productCount": "Produkt Menge Slider",
	"productWidget.new.fields.programme": "Programm ID",
	"productWidget.new.fields.quickSelect": "Schnellauswahl",
	"productWidget.new.fields.shop": "Shop",
	"productWidget.new.fields.sort": "Sortierung",
	"productWidget.new.fields.subId": "Sub-ID",
	"productWidget.new.fields.topsellerFilter": "Topseller Filter",
	"productWidget.new.filter.individual": "Individuell",
	"productWidget.new.filter.overall": "Overall",
	"productWidget.new.layout.centered": "Mittig",
	"productWidget.new.layout.default": "Standard",
	"productWidget.new.optional": "optional",
	"productWidget.new.previewHint": "Um eine Vorschau zu erhalten, musst du mindestens einen Shop auswählen.",
	"productWidget.new.productCountValue": "{count} Produkte",
	"productWidget.new.productSelection": "Produkt Auswahl",
	"productWidget.new.programmePlaceholder": "Füge hier deine Programm ID hinzu",
	"productWidget.new.saveError": "Product Widget konnte nicht gespeichert werden. Bitte versuche es erneut.",
	"productWidget.new.saveSuccess": "Product Widget wurde gespeichert.",
	"productWidget.new.shopPlaceholder": "Wähle einen Shop aus",
	"productWidget.new.skuHint": "Du findest die Produktnummern direkt auf der Produktseite im",
	"productWidget.new.skuPlaceholder": "Produktnummer (SKU) eingeben",
	"productWidget.new.skuShopLink": "{shop}-Shop",
	"productWidget.new.sort.priceAsc": "Preis aufsteigend",
	"productWidget.new.sort.priceDesc": "Preis absteigend",
	"productWidget.new.step.layout": "Layout",
	"productWidget.new.step.product": "Produkt",
	"productWidget.new.step.tracking": "Tracking",
	"productWidget.new.subIdDescription": "Diese Sub-ID wird für Auswertungszwecke verwendet und deshalb automatisch generiert. Wenn du sie überschreibst, kann es zu Problemen bei der Auswertung kommen. Bitte passe sie nur an, wenn du weißt, was du tust.",
	"productWidget.new.subIdPlaceholder": "Sub-ID (optional)",
	"productWidget.new.subcategoryPlaceholder": "Nach Subkategorie…",
	"productWidget.new.topsellerFilterDescription": "Overall zeigt die Topseller des Shops. Individuell filtert die Produkte dynamisch.",
	"productWidget.new.type.dynamic": "Topseller",
	"productWidget.new.type.static": "Produkt Suche",
	"productWidget.preview.backToOverview": "Zur Übersicht",
	"productWidget.preview.description": "So wird dein Widget auf deiner Website dargestellt.",
	"productWidget.preview.title": "Widget-Vorschau",
	"productWidget.table.actions.copyHtml": "HTML kopieren",
	"productWidget.table.actions.delete": "Löschen",
	"productWidget.table.actions.duplicate": "Duplizieren",
	"productWidget.table.actions.edit": "Bearbeiten",
	"productWidget.table.actions.preview": "Vorschau",
	"productWidget.table.clicks": "Klicks",
	"productWidget.table.empty": "Noch keine Product Widgets erstellt.",
	"productWidget.table.impressions": "Impressions",
	"productWidget.table.name": "Name",
	"productWidget.table.type": "Verhalten",
	"programme.button.programmeDetails": "Details ansehen",
	"programme.hint.enableCompactUrl": "Von Clickfire bereitgestellter Shortlink",
	"programme.label.addSubIds": "Sub IDs hinzufügen",
	"programme.label.applicationStatus": "Status",
	"programme.label.appliedAt": "Beworben am",
	"programme.label.creative": "Creative (Optional)",
	"programme.label.customUrl": "Benutzerdefinierte URL",
	"programme.label.enableCompactUrl": "Kompakte URL",
	"programme.label.note": "Hinweis",
	"programme.noValidApplicationDate": "Unbekannt",
	"programme.placeholder.creative": "Creative auswählen",
	"programme.placeholder.customUrl": "Deine benutzerdefinierte URL eingeben...",
	"programme.placeholder.subId1": "Sub ID 1",
	"programme.placeholder.subId2": "Sub ID 2",
	"programmeAccessStatus.grantedBy": "Zugriff erteilt von {0}",
	"programmeAccessStatus.hasAccess": "Zugriff erteilt",
	"programmeAccessStatus.noAccess": "Kein Zugriff",
	"programmeAccessStatus.onHold": "Zurückgestellt",
	"programmeAccessStatus.pending": "Bewerbung offen",
	"programmeAccessStatus.rejected": "Abgelehnt",
	"programmeAccessStatus.revokedBy": "Zugriff verweigert von {0}",
	"programmeApplication.acceptedBy": "Akzeptiert von {0}",
	"programmeApplication.appliedToProgramme": "Bewerbung auf",
	"programmeApplication.button.approve": "Bewerbung annehmen",
	"programmeApplication.button.approveDisabled": "Programmzugriff kann nur gewährt werden, wenn für den Affiliate eine Provisionsgruppe hinterlegt ist.",
	"programmeApplication.button.reject": "Bewerbung ablehnen",
	"programmeApplication.details.city": "Wohnort:",
	"programmeApplication.details.country": "Land:",
	"programmeApplication.details.descriptionPromotionMethod": "So möchte ich das Programm bewerben",
	"programmeApplication.details.eMailAddress": "E-Mail Adresse:",
	"programmeApplication.details.highestReachCountry": "Land mit größter Reichweite:",
	"programmeApplication.details.recommendedBy": "Empfohlen durch:",
	"programmeApplication.details.title": "Angaben des Bewerbers",
	"programmeApplication.individualPayout.amountInPercent.label": "Prozentualer Wert (%)",
	"programmeApplication.individualPayout.description": "Überschreibt Provision der Gruppe",
	"programmeApplication.individualPayout.label": "Individuellen Payout auszahlen",
	"programmeApplication.individualPayout.referrerBonus.label": "Referrer Bonus (%)",
	"programmeApplication.noChannelsData": "Der Bewerber hat keine Angaben zu seinen Kanälen gemacht",
	"programmeApplication.onHold": "On Hold",
	"programmeApplication.rejectedBy": "Abgelehnt von {0}",
	"programmeApplication.rejection.general": "Allgemein",
	"programmeApplication.rejection.policy": "Past nicht zur Affiliate Policy",
	"programmeApplication.rejection.reach": "Zu geringe Reichweite",
	"programmeApplication.rejection.topic": "Nicht themenspezifisch",
	"reachFilter.all.label": "Alle Reichweiten",
	"segments.label.singleUsers": "Einzelne User",
	"sidebar.signedInAs": "Eingeloggt als",
	"state.admin.submission.approved": "Angenommen",
	"state.admin.submission.exceeded": "Abgelaufen",
	"state.admin.submission.missing": "Fehlende Einsendung",
	"state.admin.submission.rejected": "Abgelehnt",
	"state.admin.submission.submitted": "Überprüfen",
	"state.approved": "Genehmigt",
	"state.paid": "Bezahlt",
	"state.pending": "Offen",
	"state.rejected": "Abgelehnt",
	"state.submission.approved": "Einsendung akzeptiert",
	"state.submission.exceeded": "Einsendungszeitraum leider abgelaufen",
	"state.submission.missing": "Einsendung erforderlich",
	"state.submission.paidOut": "Einsendung ausgezahlt",
	"state.submission.rejected": "Einsendung abgelehnt",
	"state.submission.submitted": "Wird geprüft",
	"state.unapproved": "Unapproved",
	"state.unknown": "Unbekannt",
	"submission.label.creationDate": "Eingesendet am",
	"submission.property.category": "Kategorie",
	"submission.property.codeExpiryDate": "Gültigkeitsdauer",
	"submission.property.compensation": "Vergütung",
	"submission.property.createdAt": "Datum der Einsendung",
	"submission.property.state": "Status",
	"submission.property.tiktokCode": "TikTok-Code",
	"submissionState": "Einsendung: {0}",
	"submissions.label.onlyShowOpenSubmissions": "Nur offene Einsendungen",
	"submissions.noSubmissions.title": "Keine Einsendungen vorhanden",
	"table.adminConversions.noEntries": "Für die aktuelle Auswahl gibt es keine Conversions",
	"table.adminPayouts.noEntries": "Es gibt noch keine Auszahlungen",
	"table.adminPayouts.title.actions": "Download",
	"table.adminPayouts.title.affiliate": "Affiliate",
	"table.adminPayouts.title.affiliateId": "AffiliateID",
	"table.adminPayouts.title.compensation": "Betrag",
	"table.adminPayouts.title.date": "Rechnungsdatum",
	"table.adminPayouts.title.id": "Rechnungsnummer",
	"table.adminPayouts.title.payout": "Auszahlungsbetrag",
	"table.adminSubmissions.noEntries": "Für diese Kampagne gibt es noch keine Einsendungen",
	"table.adminSubmissions.title.actions": "Annehmen",
	"table.adminSubmissions.title.affiliate": "Affiliate",
	"table.adminSubmissions.title.affiliateId": "AffiliateID",
	"table.adminSubmissions.title.contentUrl": "Einsendungslink",
	"table.adminSubmissions.title.creator": "Creatorname",
	"table.adminSubmissions.title.date": "Datum",
	"table.adminSubmissions.title.details": "Details",
	"table.adminSubmissions.title.rejectionInformation": "Ablehnungsgrund",
	"table.adminSubmissions.title.state": "Status",
	"table.applications.title.actions": "Bewerbung",
	"table.applications.title.applicationDate": "Bewerbungszeitpunkt",
	"table.applications.title.categories": "Produktkategorien",
	"table.applications.title.creator": "Creatorname",
	"table.applications.title.followerCount": "Follower",
	"table.applications.title.languages": "Sprachen",
	"table.applications.title.platforms": "Plattformen",
	"table.applications.title.state": "Status",
	"table.clicks.noEntries": "Du hast noch keine Klicks",
	"table.conversions.noEntries": "Du hast noch keine Conversions",
	"table.conversions.title.invoiceNumber": "Gutschriftnummer",
	"table.conversions.title.orderNumber": "Bestellnummer",
	"table.conversions.title.partner": "Partner",
	"table.conversions.title.payout": "Provision",
	"table.conversions.title.programme": "Programm",
	"table.conversions.title.rejectionReason": "Ablehnungsgrund",
	"table.conversions.title.saleAmount": "Bestellwert",
	"table.conversions.title.status": "Freigabestatus",
	"table.footer.entriesPerPage": "Einträge pro Seite",
	"table.generic.title.date": "Datum",
	"table.generic.title.publisherId": "Publisher ID",
	"table.generic.title.referrer": "Referrer",
	"table.generic.title.subId1": "Sub ID 1",
	"table.generic.title.subId2": "Sub ID 2",
	"table.networkReport.noEntries": "Keine passenden Partner gefunden",
	"table.noEntries": "Keine Einträge vorhanden",
	"table.payouts.footer.payoutSum": "Summe aller Auszahlungen",
	"table.payouts.noEntries": "Du hast noch keine Auszahlungen",
	"table.payouts.title.actions": "Download",
	"table.payouts.title.amount": "Auszahlungsbetrag",
	"table.payouts.title.date": "Rechnungsdatum",
	"table.payouts.title.id": "Rechnungsnummer",
	"table.payouts.title.merchant": "Merchant",
	"table.pecHistory.campaignCompleted": "Kampagne abgeschlossen",
	"table.pecHistory.campaignOngoing": "Kampagne läuft noch",
	"table.pecHistory.hasSubmission": "Einsendung vorhanden",
	"table.pecHistory.noEntries": "Keine Kampagnenbeteiligungen vorhanden",
	"table.pecHistory.noSubmission": "Keine Einsendung",
	"table.pecHistory.title.campaignCompleted": "Kampagne abgeschlossen",
	"table.pecHistory.title.campaignName": "Name der Kampagne",
	"table.pecHistory.title.company": "Firma",
	"table.pecHistory.title.compensationReceived": "Vergütung erhalten",
	"table.pecHistory.title.status": "Bewerbungsstatus",
	"table.products.noEntries": "Keine Transaktionen gefunden",
	"table.products.title.articleNumber": "Artnr.",
	"table.products.title.category": "Kategorie",
	"table.products.title.grossNet": "Umsatz (netto)",
	"table.products.title.grossSum": "Umsatz (brutto)",
	"table.products.title.imageUrl": "Produktbild",
	"table.products.title.name": "Name",
	"table.products.title.priceGross": "Preis (Brutto)",
	"table.products.title.priceNet": "Preis (Netto)",
	"table.products.title.quantity": "Stückzahl",
	"table.segmentCreators.empty.action": "Creator hinzufügen",
	"table.segmentCreators.empty.description": "Dieser Creatorgruppe sind noch keine Creator hinzugefügt.",
	"table.segmentCreators.empty.title": "Keine Creator vorhanden",
	"table.segmentCreators.title.actions": "Aktionen",
	"table.submissions.emptyState": "Noch keine Einsendungen vorhanden",
	"table.submissions.title.campaign": "Kampagne",
	"table.submissions.title.date": "Datum",
	"table.submissions.title.details": "Details",
	"table.submissions.title.merchant": "Merchant",
	"table.submissions.title.state": "Status",
	"toast.applyToProgramme.error.alreadyApproved": "Du bist bereits für dieses Programm freigeschaltet.",
	"toast.applyToProgramme.error.applicationPending": "Du hast dich bereits auf dieses Programm beworben.",
	"toast.applyToProgramme.error.description": "Ein unbekannter Fehler ist aufgetreten. Bitte versuche es erneut oder wende dich an unseren Support.",
	"toast.applyToProgramme.error.title": "Fehler beim Bewerben",
	"toast.applyToProgramme.needsToCompleteAccountSetup.title": "Damit du dich auf das Programm bewerben kannst, musst du zuerst dein Profil vervollständigen.",
	"toast.applyToProgramme.rejectedByMerchant.title": "Du wurdest leider für das Netzwerk abgelehnt und kannst dich deshalb nicht auf das Programm bewerben",
	"toast.applyToProgramme.success.title": "Bewerbung erfolgreich versendet",
	"toast.approveSubmission.success.title": "Die Einsendung wurde erfolgreich akzeptiert",
	"toast.archiveCampaign.success.title": "Die Kampagne wurde erfolgreich archiviert",
	"toast.campaigns.translateWithAi.noSourceLocalization": "Damit die KI deinen Inhalt übersetzen kann, muss mindestens eine Sprache vollständig ausgefüllt sein.",
	"toast.changeBillingInformation.error.title": "Fehler beim Ändern der Rechnungsdaten",
	"toast.changeBillingInformation.success.title": "Deine Rechnungsdaten wurden erfolgreich geändert",
	"toast.changeBillingInformation.unknownError.title": "Ein unbekannter Fehler beim Ändern der Rechnungsdaten",
	"toast.changePaymentInformation.error.title": "Fehler bei der Einsendung",
	"toast.changePaymentInformation.success.title": "Deine Zahlungsinformationen wurden erfolgreich geändert",
	"toast.changePaymentInformation.unknownError.title": "Ein unbekannter Fehler bei der Einsendung",
	"toast.changeQuestionaireInformation.error.title": "Fehler bei der Einsendung",
	"toast.changeQuestionaireInformation.unkownError.title": "Ein unbekannter Fehler bei der Einsendung",
	"toast.changeQuestionnaireData.error.title": "Fehler beim Ändern der Bewerbungsdaten",
	"toast.changeQuestionnaireData.success.title": "Deine Bewerbungsdaten wurden erfolgreich geändert",
	"toast.changeQuestionnaireData.unknownError.title": "Ein unbekannter Fehler beim Ändern der Bewerbungsdaten",
	"toast.confirmedEmailButNeedLogin.description": "Du kannst dich nun mit deiner E-Mail-Adresse und deinem Passwort anmelden",
	"toast.confirmedEmailButNeedLogin.title": "Deine E-Mail-Adresse wurde erfolgreich bestätigt",
	"toast.copyPromotionLink.error": "Fehler beim Kopieren des Links. Bitte versuche es erneut.",
	"toast.createProfile.error.title": "Dein Profil konnte nicht angelegt werden.",
	"toast.createProgrammeLink.error.description": "Bitte versuche es erneut.",
	"toast.createProgrammeLink.error.title": "Der Link konnte nicht erstellt werden",
	"toast.dateRangePickerMaxRange.error.description": "Der Zeitraum darf maximal {duration} betragen.",
	"toast.dateRangePickerMaxRange.error.title": "Zu langer Zeitraum",
	"toast.downloadAsCsv.error.title": "Fehler beim CSV Download",
	"toast.downloadReportAsCsv.error.invalidDate": "Das angegebene Datum ist ungültig.",
	"toast.downloadReportAsCsv.error.noItems": "Es wurden keine Ergebnisse gefunden.",
	"toast.downloadReportAsCsv.error.parse": "Die Daten konnten nicht verarbeitet werden.",
	"toast.downloadReportAsCsv.error.server": "Der Report konnte nicht geladen werden. Bitte versuche es später erneut.",
	"toast.editCampaign.success.title": "Die Kampagne wurde erfolgreich aktualisiert",
	"toast.isRedirectedFromAnotherSpace.description": "Du hast versucht, dich bei einem anderen Merchant anzumelden. Aus Sicherheitsgründen musst du deine Anmeldedaten noch einmal eingeben.",
	"toast.isRedirectedFromAnotherSpace.title": "Du musst dich noch einmal anmelden",
	"toast.login.error.title": "Login fehlgeschlagen",
	"toast.newCampaign.error.title": "Es ist ein Fehler beim Erstellen der Kampagne aufgetreten",
	"toast.newCampaign.success.title": "Die Kampagne wurde erfolgreich erstellt",
	"toast.newPassword.error.title": "Passwort konnte nicht geändert werden",
	"toast.newPassword.success.title": "Passwort wurde erfolgreich geändert!",
	"toast.rejectSubmission.success.title": "Die Einsendung wurde erfolgreich abgelehnt",
	"toast.resetPassword.error.title": "Passwort konnte nicht zurückgesetzt werden",
	"toast.saveChannels.error.description": "Ein oder mehrere Kanäle konnten nicht gespeichert oder gelöscht werden.",
	"toast.saveChannels.error.title": "Fehler beim Speichern der Kanäle",
	"toast.signup.error.title": "Registrierung fehlgeschlagen",
	"toast.signupWithV1Account.error.description": "Ein unbekannter Fehler bei der Registrierung ist aufgetreten. Bitte überprüfe deine Angaben oder versuche es später erneut.",
	"toast.signupWithV1Account.error.title": "Fehler bei der Registrierung",
	"toast.submitSubmission.error.title": "Fehler bei der Einsendung",
	"toast.submitSubmission.unknownError.title": "Ein unbekannter Fehler bei der Einsendung",
	"toast.unauthorized.description": "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.",
	"toast.unauthorized.title": "Du musst dich erneut anmelden",
	"toast.updateAccount.admin.success.title": "Profil erfolgreich aktualisiert",
	"toast.updateAccount.error.title": "Dein Profil konnte nicht aktualisiert werden",
	"toast.updateAccount.success.title": "Dein Profil wurde erfolgreich aktualisiert",
	"toast.updateCampaign.success.title": "Kampagne erfolgreich gespeichert",
	"toast.updateChannels.success.title": "Deine Kanal-Informationen wurden erfolgreich gespeichert",
	"toast.validation.error.description": "Bitte überprüfe die markierten Felder.",
	"toast.validation.error.title": "Deine Eingaben sind unvollständig",
	"tooltip.blocked": "Zugriff gesperrt",
	"tooltip.cpi.body": "Errechnet sich aus der Menge und dem Wert der Conversions, die der Creator in den letzten 90 Tagen verursacht hat. Je höher der Wert, desto besser. Maximal kann ein Wert von 10 erreicht werden.",
	"tooltip.cpi.title": "Clickfire Perfomance Index:",
	"tooltip.customProgrammePayoutModality": "Für dieses Programm hast du eine personaliserte Provisionshöhe, die höher ausfällt, als die Standard Provision.",
	"tooltip.inactive": "Der User hat noch keine Conversions. Wir stufen ihn deshalb als inaktiv ein.",
	"tooltip.inactive.withDate": "Die letzte Conversion des Users war am {0}. Wir stufen ihn deshalb als inaktiv ein.",
	"tooltip.v1User.description": "Der User hat sich bisher noch nicht bei Clickfire v2 angemeldet. Wir können deshalb nicht alle Daten darstellen.",
	"tooltip.v1User.label": "v1 User",
	"topbar.links.admin.applications.history": "Bewerbungshistorie",
	"topbar.links.admin.applications.onhold": "Zurückgestellte Bewerbungen",
	"topbar.links.admin.applications.open": "Offene Bewerbungen",
	"topbar.links.admin.campaigns.active": "Aktive Kampagnen",
	"topbar.links.admin.campaigns.archived": "Archiv",
	"topbar.links.admin.campaigns.draft": "Entwürfe",
	"topbar.links.affiliates": "Partner Register",
	"topbar.links.applications": "Bewerbungsübersicht",
	"topbar.links.availableCampaigns": "Verfügbare Kampagnen",
	"topbar.links.availableProgrammes": "Verfügbare Programme",
	"topbar.links.campaigns": "Kampagnen",
	"topbar.links.clickReport": "Click Report",
	"topbar.links.clickReportRealtime": "Echtzeit Clicks",
	"topbar.links.conversions": "Conversion Report",
	"topbar.links.dashboard": "Dashboard",
	"topbar.links.domains": "Domains",
	"topbar.links.partnerReport": "Netzwerk Report",
	"topbar.links.payouts": "Auszahlungen",
	"topbar.links.productReport": "Product Report",
	"topbar.links.productWidget": "Product Widget",
	"topbar.links.productWidgetsOverview": "Übersicht",
	"topbar.links.programmes": "Programme",
	"topbar.links.segments": "Creatorgruppen",
	"topbar.links.submissions": "Einsendungen",
	"topbar.links.yourProgrammeApplications": "Deine Bewerbungen",
	"topbar.links.yourProgrammes": "Deine Programme",
	"topbar.userMenu.links.account": "Profileinstellungen",
	"topbar.userMenu.links.adminDashboard": "Merchant Dashboard",
	"topbar.userMenu.links.logout": "Abmelden",
	"topbar.userMenu.links.merchantDashboard": "Affiliate Dashboard",
	"validation.error.bic": "Ungültige BIC",
	"validation.error.campaign.localizationMinimum": "Es musst mindestens eine Sprache hinterlegt sein.",
	"validation.error.campaign.type": "Es muss ein Kampagnentyp ausgewählt sein.",
	"validation.error.compensation": "Die Vergütung muss mindestens 0,01 € betragen",
	"validation.error.confirmTos": "Die Zustimmung der AGBs ist verpflichtend",
	"validation.error.default": "Ungültige Eingabe",
	"validation.error.duplicate.channelUri": "Diese URL ist bei mehreren Kanälen eingetragen",
	"validation.error.email": "Ungültige E-Mail-Adresse",
	"validation.error.endDate": "Das Enddatum darf nicht früher als der {0} sein",
	"validation.error.endDate.atLeastOneDay": "Das Datum darf nicht heute sein oder in der Vergangenheit liegen",
	"validation.error.endDate.onlyExtendAllowed": "Du darfst das Enddatum nur verlängern aber nicht verkürzen.",
	"validation.error.iban": "Ungültige IBAN",
	"validation.error.invalid.date": "Ungültiges Datum",
	"validation.error.invalid.url": "Es wird eine gültige URL im Format https://domain.de benötigt",
	"validation.error.invalidImageDimensions": "Die Auflösung des Bildes ist zu gering. Bitte verwende ein Bild mit mindestens {width}x{height}px.",
	"validation.error.invalidImageFormat": "Bitte wähle ein gültiges Dateiformat aus ({0})",
	"validation.error.length": "Dieses Feld muss mindestens {0} Zeichen beinhalten.",
	"validation.error.localization.atLeastOne": "Es muss mindestens eine Sprache ausgefüllt sein",
	"validation.error.notANumber": "Ungültige Zahl",
	"validation.error.notAnImage": "Bitte wähle ein gültiges Bild aus",
	"validation.error.notEqual": "Die Passwörter stimmen nicht überein",
	"validation.error.number.noFloat": "Dieses Feld darf keine Zahlen mit , oder . enthalten",
	"validation.error.postalCode": "Keine gültige Postleitzahl für {country}",
	"validation.error.required": "Dieses Feld ist ein Pflichtfeld",
	"validation.error.startDate": "Das Startdatum darf nicht früher als der {0} sein",
	"validation.error.tags.required": "Es wird mindestens ein Content-Tag benötigt",
	"validation.error.tooBig.number": "Die Zahl darf nicht größer als {0} sein.",
	"validation.error.tooSmall.array": "Dieses Feld ist ein Pflichtfeld",
	"widget.affilateDetails.accountManager": "Account-Manager",
	"widget.affilateDetails.subId1": "Affiliate Sub-ID 1",
	"widget.affilateDetails.subId2": "Affiliate Sub-ID 2",
	"widget.affilateDetails.title": "Affiliates",
	"widget.networkSelectionPerformanceGraph.action.clearSelection": "Auswahl leeren",
	"widget.networkSelectionPerformanceGraph.action.removeFromSelection": "Aus Auswahl entfernen",
	"widget.networkSelectionPerformanceGraph.label.selection": "Auswahl:",
	"widget.networkSelectionPerformanceGraph.label.wholeNetwork": "Gesamtnetzwerk",
	"widget.payment.billingAndTaxes.title": "Abrechnung & Steuern",
	"widget.payment.billingData.title": "Rechnungsdaten",
	"widget.payment.misc.title": "Sonstiges",
	"widget.payment.paymentInfo.title": "Zahlungsinformationen",
	"widget.performanceGraph.label.clicks": "Klicks",
	"widget.performanceGraph.label.conversions": "Conversions",
	"widget.performanceGraph.label.payouts": "Provision",
	"widget.performanceGraph.label.sales": "Sales Value",
	"widget.performanceGraph.missingPublisherId.description": "Für diesen Partner können keine Performance-Daten geladen werden.",
	"widget.performanceGraph.missingPublisherId.title": "Keine Publisher ID hinterlegt",
	"widget.performanceGraph.showUnapprovedConversions": "Unbestätigte Conversions anzeigen",
	"widget.performanceGraph.title": "Performance Graph",
	"widget.performanceGraph.trend": "Trend",
	"widget.topProducts.noContent": "Für diesen Zeitraum wurden leider keine Produkte gefunden.",
	"widget.yourAffiliateLinks.title": "Deine Tracking-Links",
	"widget.yourApplications.title": "Status deiner Bewerbung"
}
